export default __webpack_public_path__ + "static/assets/med_x_eye_drops.a9478a52.png";